import { Component, Prop, Vue } from "vue-property-decorator";

import { CreateElement } from "vue";

@Component
export default class RadioTable extends Vue {
  @Prop() questions!: any;
  @Prop({ default: false }) fixHeader!: boolean;
  @Prop() disabled!: boolean;
  @Prop({ default: 0 }) labelType!: number;

  header = this.fixHeader;
  container: any;
  zIndex: number = 10;
  // labelSelections = [
  //   [
  //     // type 2
  //     "Definitely Not",
  //     "Not Much",
  //     "A bit",
  //     "Yes, Mostly",
  //     "Yes, Definitely"
  //   ],
  //   [
  //     // type 0
  //     "Not well at all",
  //     "Not very well",
  //     "Somewhat well",
  //     "Pretty well",
  //     "Very well"
  //   ],
  //   [
  //     // type 1
  //     "Not at all interesting",
  //     "Not very interesting",
  //     "Somewhat interesting",
  //     "Pretty interesting",
  //     "Very interesting"
  //   ]
  // ];
  labelSelections: any;

  constructor() {
    super();
    this.labelSelections = this.$store.getters.radioHeaders;
  }

  beforeCreate() {
    this.labelSelections = this.$store.getters.radioHeaders;
  }

  mounted() {
    this.container = document.getElementById("radioContainer");
    if (this.fixHeader == true) {
      window.addEventListener("scroll", this.scroll);
      window.addEventListener("resize", this.updateStyle);
      this.updateStyle();
    }
  }

  scroll() {
    if (window.scrollY > 0) {
      this.header = false;
    } else {
      this.header = true;
      this.updateStyle();
    }
  }

  updateStyle() {
    this.$forceUpdate();
  }

  beforeDestroy() {
    window.removeEventListener("scroll", this.scroll);
    window.removeEventListener("resize", this.updateStyle);
  }

  isComplete() {
    let completed = true;
    this.questions.forEach((question: any) => {
      if (question.answer < 0) {
        completed = false;
      }
    });
    this.$emit("update", completed);
  }

  updated() {
    this.isComplete();
  }

  stateLoaded() {
    this.labelSelections = this.$store.getters.radioHeaders;
    let obj = this.$store.getters.radioHeaders;
    return !(Object.keys(obj).length === 0);
  }

  main(fixedRow: any) {
    return (
      <div style="max-height: 300px; overflow-y: scroll; position: relative;">
        <v-container id="radioContainer" style={{ paddingTop: "0px" }}>
          <v-row
            align="baseline"
            style={this.header ? fixedRow : {}}
            no-gutters
          >
            <v-col cols="4" align-self="center"></v-col>
            <v-col cols="8">
              <v-row justify="center" no-gutters style={{ fontSize: "85%" }}>
                {this.labelSelections[this.labelType] &&
                  this.labelSelections[this.labelType].map(
                    (header: any, i: number) => (
                      <v-col align-self="center" class="text-center">
                        {header}
                      </v-col>
                    )
                  )}
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              style={{
                display: this.header ? "block" : "none",
                color: "#fff"
              }}
            >
              Placeholder
            </v-col>
          </v-row>
          {this.questions &&
            this.questions.map((question: any, i: number) => (
              <v-row
                align="center"
                no-gutters
                style={{ paddingBottom: "20px" }}
              >
                <v-col cols="4">{question.question}</v-col>
                <v-col cols="8">
                  <v-row no-gutters>
                    {[0, 1, 2, 3, 4].map(n => (
                      <v-col align="center" class="text-center">
                        <v-radio-group
                          v-model={this.questions[i].answer}
                          style="display: inline-block;"
                        >
                          <v-radio
                            disabled={this.disabled}
                            key={n}
                            value={n}
                            style="margin-right: -10px"
                          ></v-radio>
                        </v-radio-group>
                      </v-col>
                    ))}
                  </v-row>
                </v-col>
              </v-row>
            ))}
        </v-container>
      </div>
    );
  }

  render(h: CreateElement) {
    const fixedRow: any = {
      position: "fixed",
      width: this.container
        ? this.container.clientWidth - 24 + "px"
        : "inherit",
      backgroundColor: "white",
      zIndex: 10
    };

    return this.stateLoaded() ? this.main(fixedRow) : "";
  }
}

const component = RadioTable;
